export const REDIRECT = {
  pwa: "https://em-pwa-pay.moxey.ai",
  web: "https://em-pay.moxey.ai",
};
